export default __webpack_public_path__ + "/dist/images/appstore.10ef3e51cde1bfe90a2a4d500ee28661.png";